export default __webpack_public_path__ + "static/media/trianguloInvertidoSuperiorAzulVazio.3f46a8a6.png";